'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { formatDate, formatTime } from '../../utils/TimeUtils';
import AppointmentTime from '../../dto/AppointmentTime';
import Row from '../tag/Row';
import Span from '../tag/Span';

import Logger from '../../utils/Logger';
import { getDepartmentDisplay } from '../../utils/TimelineUtils';
import OTIcon from '../tag/OTIcon';

let { id: module_id } = module;

const AppointmentListItem = ({ data, children }) => {
  let startDate = null,
    startTime = null,
    endTime = null,
    location = null;

  if (data.dateStart) {
    startDate = formatDate(data.dateStart);
    startTime = formatTime(data.dateStart);
  }

  if (data.dateEnd) {
    endTime = formatTime(data.dateEnd);
  }

  if (data.location) {
    location = getDepartmentDisplay(data.location);
  }

  let classNames = classnames('appointment', 'appointment--blue');
  return (
    <li className={classNames} style={{ width: '100%' }}>
      <Row>
        <Span len="3" sm-len="12">
          <OTIcon
            config={{ type: 'fa', name: 'fa-check', color: 'blue' }}
            className={'show-desktop'}
            style={{ marginRight: '10px' }}
          />
          <span className={'appointment-bold'}>{startDate}</span>
        </Span>
        <Span className={'appointment-bold'} len="3" sm-len="12">
          <span>{`kello ${startTime} - ${endTime}`}</span>
        </Span>
        <Span len="3" sm-len="12">
          <span>{location}</span>
        </Span>
        {children && (
          <Span len="3" sm-len="12">
            {children}
          </Span>
        )}
      </Row>
    </li>
  );
};

AppointmentListItem.propTypes = {
  data: PropTypes.instanceOf(AppointmentTime).isRequired,
};

export default AppointmentListItem;
